import { apiClient } from '@/api/client'
import { SESSION_WALLBOARD } from '@/api/endpoints'
import type { ApiResponseWrapper } from '@/types/api.types'
import type {
  WallboardBoard,
  WallboardQuery,
} from '@/features/wallboard/types/wallboard.types'
import {
  normalizeWallboardQuery,
  wallboardQueryToParams,
} from '@/features/wallboard/utils/wallboardQuery'

const EMPTY_TOTALS: WallboardBoard['totals'] = {
  companies: 0,
  members: 0,
  clockedIn: 0,
  online: 0,
  idle: 0,
  offline: 0,
  onBreak: 0,
  noShow: 0,
  dueSoon: 0,
}

function toBoard(payload: Partial<WallboardBoard> | undefined): WallboardBoard {
  return {
    serverTime: payload?.serverTime ?? new Date().toISOString(),
    allowedCompanyIds: Array.isArray(payload?.allowedCompanyIds)
      ? payload.allowedCompanyIds
      : undefined,
    totals: { ...EMPTY_TOTALS, ...(payload?.totals ?? {}) },
    companies: Array.isArray(payload?.companies) ? payload.companies : [],
    truncated: Boolean(payload?.truncated),
    // Older servers don't send it; assume the flags are fine.
    shiftStatusAvailable: payload?.shiftStatusAvailable !== false,
  }
}

export async function getSessionWallboard(
  query?: WallboardQuery,
): Promise<WallboardBoard> {
  const normalized = normalizeWallboardQuery(query)
  const { data } = await apiClient.get<ApiResponseWrapper<WallboardBoard>>(
    SESSION_WALLBOARD,
    { params: wallboardQueryToParams(normalized) },
  )
  return toBoard(data?.data)
}
